module.exports = __webpack_public_path__ + "static/media/Credits-16.6a7b7c9e.pdf";